<div class="user-card" [ngClass]="view" [attr.data-test]="'card_tutor'">

  <div class="card-cover" (click)="onOpenInModal()"></div>

  <div class="cover-wrap">
<!--    <ng-container *ngIf="userPic && !mediaUrl">-->
      <on-ui-cover [cover]="userPic" [scale]="doHover" [attr.data-test]="'card_tutors_cover'"
                   [withBlur]="true"></on-ui-cover>
<!--    </ng-container>-->

<!--    <ng-container *ngIf="mediaUrl">-->
<!--      <div class="this-video" [class.scale]="doHover">-->
<!--        <video class="video-background" playsinline>-->
<!--          <source [src]="mediaUrl" type="video/mp4"/>-->
<!--        </video>-->
<!--        <video class="video" [attr.data-test]="'card_tutors_video'" playsinline>-->
<!--          <source [src]="mediaUrl" type="video/mp4"/>-->
<!--        </video>-->
<!--        <div class="video-holder" (click)="onOpenInModal()">-->
<!--          <app-icon width="50" height="50" file="action" icon="play-holder"></app-icon>-->
<!--        </div>-->
<!--      </div>-->
<!--    </ng-container>-->

    <div class="bookmark">
      <app-bookmark [notooltip]="true" [item]="user" [type]="'user'" (favoriteChanged)="favoriteChanged($event)"></app-bookmark>
    </div>
  </div>

  <div class="main-info-wrap">
    <div class="subjects-wrap" [attr.data-test]="'card_tutors_subjects'">
      <div *ngFor="let subject of teachingSubjects.slice(0, 1); trackBy: trackByFn" class="subject">{{ subject }}</div>
      <span *ngIf="teachingSubjects.slice(1).length"
            class="other-subject">+{{ teachingSubjects.slice(1).length }}</span>
    </div>

    <div class="name-wrap">
      <div class="name"
           [attr.data-test]="'card_tutors_name'">
        <a class="no-link" [href]="accountRoute">{{ fullName }}</a></div>
      <div class="flag-wrap">
        <img *ngIf="countryFlagUrl" [src]="countryFlagUrl" [alt]="countryName" class="flag">
      </div>
      <div class="verified">
        <ng-template [ngIf]="profileVerified" [ngIfElse]="noVerified">
          <app-icon height="16" width="18" file="status" icon="teacher-verify" class="verify"></app-icon>
        </ng-template>

        <ng-template #noVerified>
          <app-icon height="16" width="18" file="status" icon="teacher-no-verify" class="no-verify"></app-icon>
        </ng-template>
      </div>
    </div>

    <div class="speak-info" *ngIf="view !== 'wide-horizontal'">
      <ng-template [ngIf]="speakLanguages?.length">
        <div class="text">{{ 'library.user-mini-card.speak-on' | customLocale }}</div>
        <div class="text" *ngFor="let language of speakLanguages; let last = last">{{ language?.title }}<span *ngIf="!last">,</span></div>
      </ng-template>
    </div>

    <div class="about-wrap" *ngIf="view==='vertical' && about">
      <p class="about">{{about}}</p>
    </div>

    <div class="stat-block" *ngIf="view !== 'wide-horizontal'">
      <ng-template [ngIf]="stats && stats.meetings_count">
        <span>{{'teacher-card.stats.classes' | customLocale}} {{stats.meetings_count}}</span>
      </ng-template>
      <ng-template [ngIf]="stats && stats.students_count">
        <span>{{'teacher-card.stats.students' | customLocale}} {{stats.students_count}}</span>
      </ng-template>
      <app-rating [stats]="stats"></app-rating>
    </div>

    <div class="price-wrap" [attr.data-test]="'card_tutors_price'">
      <ng-template [ngIf]="stats && stats.min_price_tier">
        <span class="price-tier-label">{{ 'library.user-mini-card.from' | customLocale }}</span>
        <span class="price-tier">{{  getFormattedAmount() | async }}</span>
        <span class="price-tier-label">{{ 'library.user-mini-card.price' | customLocale }}</span>
      </ng-template>
    </div>

  </div>
</div>
